import { useContext, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Box,
  IconButton,
  Collapse,
  AvatarGroup,
  Avatar,
} from "@mui/material";
import { ControlPoint, Send } from "@mui/icons-material";
import CustomText from "../components/CustomText";
import CustomButton from "../components/CustomButton";
import { ScreenContext } from "../context/ScreenContext";
import { useLocation } from "react-router-dom";
import { trackEvent } from "../utils/analytics";
import { openWhatsApp } from "../utils/openWhatsApp";
import { Helmet } from "react-helmet-async";

const FrequentlyQuestions = () => {
  const location = useLocation();

  const { isMobile } = useContext(ScreenContext);

  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleToggle = (index) => {
    setExpandedIndex((prev) => (prev === index ? null : index));
  };

  const handleWhatsApp = () => {
    trackEvent("whatsapp_faq", {
      page_path: location.pathname,
      page_url: window.location.href,
      section: "preguntas_frecuentes",
      cta_name: "enviar_mensaje",
      value: 1,
    });

    openWhatsApp(
      "525959570961",
      `Hola Centro Médico MEDAM 👋, tengo algunas dudas y me gustaría recibir información.`,
      true,
    );
  };

  return (
    <>
      <Helmet>
        <title>Preguntas frecuentes | Centro Médico MEDAM</title>
        <meta
          name="description"
          content="Resuelve tus dudas sobre servicios médicos, atención, aseguradoras, citas y promociones del Centro Médico MEDAM en Texcoco."
        />
        <meta
          name="keywords"
          content="preguntas frecuentes MEDAM, servicios médicos Texcoco, atención médica, aseguradoras, laboratorio, consulta médica, Centro Médico MEDAM"
        />
        <meta name="author" content="Centro Médico MEDAM" />
        <meta name="robots" content="index,follow" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="es_MX" />
        <meta property="og:site_name" content="Centro Médico MEDAM" />
        <meta
          property="og:title"
          content="Preguntas frecuentes | Centro Médico MEDAM"
        />
        <meta
          property="og:description"
          content="Encuentra respuestas rápidas sobre servicios, citas, especialidades y atención médica en Centro Médico MEDAM."
        />
        <meta
          property="og:url"
          content="https://centromedicomedam.com/preguntas-frecuentes"
        />
        <meta
          property="og:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Preguntas frecuentes | Centro Médico MEDAM"
        />
        <meta
          name="twitter:description"
          content="Resuelve tus dudas sobre atención médica, servicios y aseguradoras del Centro Médico MEDAM."
        />
        <meta
          name="twitter:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png"
        />
        <link rel="canonical" href="https://centromedicomedam.com/preguntas-frecuentes" />
      </Helmet>

      <Grid container sx={design.BackGroud} spacing={2}>
        <Grid size={design.Grid12}>
          <CustomText
            variant="subtitle1"
            color="#000"
            text="Preguntas frecuentes"
            sx={design.TextTitulo}
          >
            Preguntas frecuentes
          </CustomText>
          <CustomText
            variant="subtitle1"
            color="#000"
            text="Preguntas frecuentes"
            sx={design.DescriptionText}
          >
            Resolvemos tus dudas de manera sencilla. Explora esta sección y
            <br />
            descubre todo lo que necesitas saber sobre nuestra atención y
            servicios.
          </CustomText>
        </Grid>

        <Grid size={design.Grid1} />
        <Grid size={design.Grid10}>
          {questions.map((q, index) => (
            <Card key={index} sx={design.Card}>
              <Box onClick={() => handleToggle(index)} sx={design.Box}>
                <CustomText
                  variant="subtitle1"
                  color="#000"
                  text={q.title}
                  sx={design.title}
                >
                  {q.title}
                </CustomText>
                <IconButton
                  sx={{
                    transform:
                      expandedIndex === index
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    ...design.Icon,
                  }}
                >
                  <ControlPoint />
                </IconButton>
              </Box>
              <Collapse
                in={expandedIndex === index}
                timeout="auto"
                unmountOnExit
              >
                <CardContent sx={design.Margin}>
                  <CustomText
                    variant="subtitle1"
                    color="#000"
                    text={q.title}
                    sx={design.Description}
                  >
                    {q.detail}
                  </CustomText>
                </CardContent>
              </Collapse>
            </Card>
          ))}
        </Grid>

        <Grid size={design.Grid1} />
        <Grid size={design.Grid1} />

        <Grid size={design.Grid10}>
          <Card sx={design.Avatar}>
            <AvatarGroup spacing="small">
              <Avatar
                alt="Remy Sharp"
                src="https://mui.com/static/images/avatar/1.jpg"
              />
              <Avatar
                alt="Travis Howard"
                src="https://mui.com/static/images/avatar/2.jpg"
              />
              <Avatar
                alt="Cindy Baker"
                src="https://mui.com/static/images/avatar/3.jpg"
              />
            </AvatarGroup>
            <CustomText
              variant="subtitle1"
              color="#000"
              text="¿Aún tienes preguntas?"
              sx={design.title}
            >
              ¿Aún tienes preguntas?
            </CustomText>
            <CustomText
              variant="subtitle1"
              color="#626262"
              text="Nuestro equipo de atención al cliente esta disponible para atender tus dudas"
              sx={design.title}
            >
              Nuestro equipo de atención al cliente esta disponible para atender
              tus dudas
            </CustomText>
            <CustomButton
              type="button"
              variant="contained"
              color="success"
              colorTexto="#FFF"
              backgroundColor="#489E4D"
              width={isMobile ? "90%" : "40%"}
              height={50}
              grid={12}
              gridXS={12}
              borderRadius={10}
              style={design.Buttom}
              align={true}
              onClick={handleWhatsApp}
            >
              Enviar mensaje
              <Send sx={design.IconR} />
            </CustomButton>
          </Card>
        </Grid>
        <Grid size={design.Grid1} />
      </Grid>
    </>
  );
};

export default FrequentlyQuestions;

const design = {
  BackGroud: {
    backgroundImage: `url(https://centromedicomedam.com/IMG/centromedicoMEDAM/background_mini_logos_paquetes_del_centro-medico_MEDAM.png)`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "column",
    paddingTop: 4,
    paddingBottom: 4,
    px: 2,
  },
  TextTitulo: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 30,
      sm: 36,
      md: 50,
      lg: 50,
    },
    fontWeight: 700,
    textAlign: "center",
    mb: 4,
  },
  Buttom: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 17,
    marginTop: 20,
  },
  IconR: { transform: "rotate(-40deg)" },
  TextRedes: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 18,
    lineHeight: "normal",
    fontWeight: 700,
    textAlign: "center",
  },
  TextNum: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 18,
    lineHeight: "normal",
    fontWeight: 400,
    textAlign: "center",
  },
  Card: {
    backgroundColor: "#FFF",
    border: "2px solid #FFF",
    borderRadius: 4,
    mb: 2,
    color: "#FFF",
    overflow: "hidden",
    transition: "all 0.3s ease",
    width: "98%",
  },
  Box: {
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    px: 2,
    py: 1,
  },
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 18,
    lineHeight: "normal",
    marginTop: "2%",
    textAlign: "left",
  },
  DescriptionText: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 17,
      sm: 18,
      md: 19,
    },
    lineHeight: "normal",
    // marginTop: "21",
    textAlign: "center",
  },
  IconButton: {
    fontSize: 40,
    color: "#2349D0",
    marginLeft: 3,
  },
  title: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 18,
    fontWeight: 500,
    textAlign: "left",
  },
  Icon: {
    transition: "transform 0.3s ease",
    color: "#2349D0",
  },
  CardR: {
    width: "400px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    borderRadius: 15,
    boxShadow: "0 0 5px rgba(0,0,0,0.1)",
    padding: 25,
    backgroundColor: "#FFF",
  },
  align: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 2,
  },
  Avatar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    paddingTop: 2,
    paddingBottom: 2,
  },
  IconColor: { color: "#489E4D", fontSize: 35, marginRight: 5 },
  Margin: { pt: 0, px: 2, pb: 2 },
  Font: { fontSize: 35 },
  Grid1: { xs: 12, md: 2, xl: 2, lg: 2 },
  Grid10: { xs: 12, md: 8, xl: 8, lg: 8 },
  Grid4: { xs: 12, md: 4, xl: 4, lg: 4 },
  Grid12: { xs: 12, md: 12, xl: 12, lg: 12 },
};

const questions = [
  {
    title: "Aseguradoras",
    detail: "El pre ingreso permite agilizar el proceso antes de tu llegada.",
  },
  {
    title: "Torre médica",
    detail:
      "Trabajamos con múltiples aseguradoras reconocidas a nivel nacional.",
  },
  {
    title: "Hospitalización",
    detail: "Sí, puedes seleccionar el médico que prefieras desde nuestra web.",
  },
  {
    title: "Paquetes y promociones",
    detail: "Nuestros profesionales acuden a tu domicilio previa programación.",
  },
  {
    title: "Laboratorio Clínico",
    detail: "Nuestros profesionales acuden a tu domicilio previa programación.",
  },
  {
    title: "Laboratorio Clínico",
    detail: "Nuestros profesionales acuden a tu domicilio previa programación.",
  },
];
